import React, { useState } from "react";

function AddItem() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [cost, setCost] = useState("");
  const [kijiji, setKijiji] = useState("");
  const [ebay, setEbay] = useState("");
  const [link, setLink] = useState("");
  const [dateAdded, setDateAdded] = useState("");
  const [quantity, setQuantity] = useState(1);

    const match = document.cookie.match(new RegExp("(^| )token=([^;]+)"));

  const handleAdd = async () => {
    await fetch("https://liquidationapi.dallasagsmith.workers.dev/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            token: match[2],
            title: title,
            description: description,
            cost: cost,
            kijiji: kijiji,
            ebay: ebay,
            link: link,
            date_added: dateAdded,
            quantity: quantity
        }),
    });

    setTitle("");
    setDescription("");
    setCost("");
    setKijiji("");
    setEbay("");
    setLink("");
    setDateAdded("");
    setQuantity(1);

  };

  return (
    <div className="page-container">
      <h2>Add New Item</h2>
      <div className="card" style={{ maxWidth: "500px", margin: "0 auto" }}>
        <label style={{ fontWeight: "bold" }}>Title</label>
        <input
            style={{ width: "95%" }}
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Description</label>
        <textarea
        style={{ width: "95%" }}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Cost (per item)</label>
        <input
            style={{ width: "95%" }}
          type="number"
          value={cost}
          onChange={(e) => setCost(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Quantity</label>
        <input
            style={{ width: "95%" }}
          type="number"
          min={1}
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
        />

        <label style={{ fontWeight: "bold" }}>Date Added</label>
        <input
            style={{ width: "95%" }}
          type="date"
          value={dateAdded}
          onChange={(e) => setDateAdded(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Kijiji URL</label>
        <input
            style={{ width: "95%" }}
          type="url"
          value={kijiji}
          onChange={(e) => setKijiji(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Facebook Marketplace URL</label>
        <input
            style={{ width: "95%" }}
          type="url"
          value={ebay}
          onChange={(e) => setEbay(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Other Link</label>
        <input
            style={{ width: "95%" }}
          type="url"
          value={link}
          onChange={(e) => setLink(e.target.value)}
        />

        <button
          onClick={handleAdd}
          style={{ marginTop: "15px", width: "100%" }}
        >
          Add Item
        </button>
      </div>
    </div>
  );
}

export default AddItem;
